var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-col',[_c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"unique-opened":true,"router":true,"background-color":"#282B4C","text-color":"#A5ACB3","default-active":_vm.logUrl,"collapse":_vm.isCollapse,"collapse-transition":false}},[_c('common-menu',{attrs:{"getMenu":_vm.getMenu,"isCollapse":_vm.isCollapse}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../30/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26360f12","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../30/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideList.vue
// module id = null
// module chunks = 